// API Configuration
export const API_BASE_URL = import.meta.env.PROD
  ? "https://licitarsv1.robovisorusa.com/api"
  : "http://localhost:8000/api";

// Authentication
export const AUTH_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login/",
    REFRESH: "/auth/token/refresh/",
    LOGOUT: "/auth/logout/",
  },
  DOCUMENTS: {
    LIST: "/documents/",
    CREATE: "/documents/",
    DETAIL: (id: string) => `/documents/${id}/`,
    UPDATE: (id: string) => `/documents/${id}/`,
    DELETE: (id: string) => `/documents/${id}/`,
    CHAT_HISTORY: (id: string) => `/documents/${id}/chat_history/`,
  },
  DOCUMENT_TYPES: {
    LIST: "/document-types/",
    DETAIL: (id: string) => `/document-types/${id}/`,
  },
  PROCESSES: {
    LIST: "/processes/",
    CREATE: "/processes/",
    DETAIL: (id: string) => `/processes/${id}/`,
    UPDATE: (id: string) => `/processes/${id}/`,
    DELETE: (id: string) => `/processes/${id}/`,
  },
  CHAT: {
    SESSIONS: "/chat/sessions/",
    SESSION: (id: string) => `/chat/sessions/${id}/`,
    MESSAGES: (sessionId: string) => `/chat/sessions/${sessionId}/messages/`,
    MESSAGE: (sessionId: string, messageId: string) =>
      `/chat/sessions/${sessionId}/messages/${messageId}/`,
    SEND: "/chat/messages/",
    CLOSE: (sessionId: string) => `/chat/sessions/${sessionId}/close/`,
  },
};

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// Timeouts
export const API_TIMEOUT = 30000;
export const WS_RECONNECT_INTERVAL = 5000;
export const WS_MAX_RECONNECT_ATTEMPTS = 3;

// Cache
export const CACHE_DURATION = 5 * 60 * 1000;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Erro de conexão. Verifique sua internet.",
  UNAUTHORIZED: "Sessão expirada. Por favor, faça login novamente.",
  FORBIDDEN: "Você não tem permissão para realizar esta ação.",
  NOT_FOUND: "Recurso não encontrado.",
  SERVER_ERROR: "Erro no servidor. Tente novamente mais tarde.",
  VALIDATION_ERROR: "Por favor, verifique os campos preenchidos.",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  DOCUMENT_CREATED: "Documento criado com sucesso!",
  DOCUMENT_UPDATED: "Documento atualizado com sucesso!",
  DOCUMENT_DELETED: "Documento excluído com sucesso!",
  PROCESS_CREATED: "Processo criado com sucesso!",
  PROCESS_UPDATED: "Processo atualizado com sucesso!",
  PROCESS_DELETED: "Processo excluído com sucesso!",
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER_DATA: "user_data",
  SELECTED_DOCUMENT: "painel_selected_document_id",
  SELECTED_PROCESS: "painel_selected_processo_id",
  SELECTED_SESSION: "selected_session",
};

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DOCUMENTS: "/documents",
  CREATE_DOCUMENT: "/documents/create",
  DOCUMENT_DETAIL: (id: string) => `/documents/${id}`,
  PROCESSES: "/processes",
  CREATE_PROCESS: "/processes/create",
  PROCESS_DETAIL: (id: string) => `/processes/${id}`,
};

export const WS_BASE_URL = import.meta.env.PROD
  ? "wss://licitarsv1.robovisorusa.com/ws"
  : "ws://localhost:8000/ws";

export const APP_NAME = import.meta.env.VITE_APP_NAME || "LicitarsAI";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "1.0.0";
